import { FC, useState } from 'react';
import { icons } from './BPIcon';
import BPIconButton from './BPIconButton';

interface BPIconToggleButtonProps {
  onIcon: keyof typeof icons;
  offIcon: keyof typeof icons;
  initialOn?: boolean;
  handleToggle: (on: boolean) => void;
}

const BPIconToggleButton: FC<BPIconToggleButtonProps> = ({
  onIcon,
  offIcon,
  initialOn = true,
  handleToggle,
}) => {
  const [isOn, setIsOn] = useState(initialOn);

  const toggleOn = () => {
    setIsOn(true);
    handleToggle(true);
  };

  const toggleOff = () => {
    setIsOn(false);
    handleToggle(false);
  };

  return (
    <div className="grid relative place-content-center w-[56px] h-[56px]">
      {isOn ? (
        <BPIconButton icon={onIcon} onClick={toggleOff} />
      ) : (
        <BPIconButton icon={offIcon} onClick={toggleOn} />
      )}
    </div>
  );
};

export default BPIconToggleButton;
